module.exports = __webpack_public_path__ + "static/media/icon.d5346dbd.png";